module.exports = __webpack_public_path__ + "img/photo-0067.a3409b3e.jpg";